import { render, staticRenderFns } from "./live-dianzan-canvas.vue?vue&type=template&id=d4c2e36c&scoped=true"
import script from "./live-dianzan-canvas.vue?vue&type=script&lang=js"
export * from "./live-dianzan-canvas.vue?vue&type=script&lang=js"
import style0 from "./live-dianzan-canvas.vue?vue&type=style&index=0&id=d4c2e36c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c2e36c",
  null
  
)

export default component.exports